export const trackGoal = (el = null, goalString = null) => {
  const goalname = el ? el.dataset.goalTrigger : goalString;
  const goalURL = `/~/media/PEET/Goals/pixel?sc_trk=${goalname}&marker=${Date.now()}`;
  $.get(goalURL);
};

export const registerTrackingHandlers = () => {
  $('a[title="Share with friends"]').click(function handleClickTrack(e) { trackGoal(this); });
  $('a[title="Share with friends"]').click(function handleClickTrack(e) { trackGoal(this); });
  $('a[title="Connect on Facebook"]').click(function handleClickTrack(e) { trackGoal(this); });
  $('a[title="Connect on YouTube"]').click(function handleClickTrack(e) { trackGoal(this); });
  $('a[title="Connect on LinkedIn"]').click(function handleClickTrack(e) { trackGoal(this); });
  $('a[title="Connect on Instagram"]').click(function handleClickTrack(e) { trackGoal(this); });
  $('a[title="Contact Shorehaven mobile"]').click(function handleClickTrack(e) { trackGoal(this); });
  $('a[title="Contact Shorehaven phone"]').click(function handleClickTrack(e) { trackGoal(this); });
  $('.mdl-button.mdl-js-button.mdl-button--raised.mdl-button--colored').click(function handleClickTrack(e) { trackGoal(this); });
  $('.contact__phonenumbers a[href*="mailto"]').click(function handleClickTrack(e) { trackGoal(this); });
  $('a[href*="tel"]').click(function handleClickTrack(e) { trackGoal(this); });
  $('a[title="Share with friends"]').click(function handleClickTrack(e) { trackGoal(this); });
  $('.product__downloads-link').click(function handleClickTrack(e) { trackGoal(this); });
  $('.product__share-icon.connect__link').click(function handleClickTrack(e) { trackGoal(this); });

  // GTM click registrations
  $('a[title="Share with friends"]').click(function handleClickTrack(e) { gtmShareWithFriends(this); }); // GTM (Share with Friends)
  $('a[title="Save and compare"]').click(function handleClickTrack(e) { gtmSaveAndCompare(this); }); // GTM (Save and Compare)
  $('form[name="estate-hero-search"]').find(':submit').click(function handleClickTrack(e) { gtmLotSearch(this); }); // GTM (Lot Search) to send filter details and community object when estate-hero-search form submitted
  // $('.carousel-wrapper').click(function handleClickTrack(e) { gtmClickOnBannerCTA(this); }); // GTM (Click on Banner/CTA) this is the entire banner which isn't what they want
  // the carousel-item__cta doesn't load immediately so we're attaching it when the banner is clicked    
  $('.carousel-wrapper').on('click', '.carousel-item__cta', function handleClickTrack(e) { gtmClickOnBannerCTA(this); }); // GTM (Click on Banner/CTA)
    
};

// GTM (Share with Friends)
export const gtmShareWithFriends = (el = null) => {
  var community = {};
  var lot = {};
  var projectGAInfo = document.getElementById("ProjectGAInfo");
  var productGAInfo = document.getElementById("productGAinfo");
  console.log('gtmShareWithFriends fired');


  if (projectGAInfo != null && projectGAInfo != undefined) {
    community.name = projectGAInfo.getAttribute("data-community-name") || "corporate";
    community.region = projectGAInfo.getAttribute("data-community-region");
    community.availability = projectGAInfo.getAttribute("data-community-availability");
  }

  if (productGAInfo != null && productGAInfo != undefined) {
    var product = productGAInfo.getAttribute("data-product");
    var productJson = $.parseJSON(product);
    if (productJson != null && productJson != undefined) {
      lot.name = productJson.Name;
      lot.type = productJson.ProductType;
      lot.size = productJson.LotArea;
      lot.price = productJson.DisplayPrice;
      lot.stage = productJson.MarketingReleaseName;
      lot.bedrooms = productJson.Bedrooms;
      lot.bathrooms = productJson.Bathrooms;
      lot.car_spaces = productJson.Garage;
      lot.stories = productJson.Storeys;
      lot.product_id = productJson.ID;
      lot.open_times = productJson.DisplaySuiteText;
      lot.builder = productJson.BuilderName
      lot.frontage = productJson.LotWidth;
    }
  }

  dataLayer.push({
    event: 'social_share',
    community: community,
    lot: lot
  });
};

// GTM (Save and compare)
export const gtmSaveAndCompare = (el = null) => {
  var community = {};
  var lot = {};
  var projectGAInfo = document.getElementById("ProjectGAInfo");
  var productGAInfo = document.getElementById("productGAinfo");

  console.log('gtmSaveAndCompare fired');

  if (projectGAInfo != null && projectGAInfo != undefined) {
    community.name = projectGAInfo.getAttribute("data-community-name");
    community.region = projectGAInfo.getAttribute("data-community-region");
    community.availability = projectGAInfo.getAttribute("data-community-availability");
  }

  if (productGAInfo != null && productGAInfo != undefined) {
    var product = productGAInfo.getAttribute("data-product");
    var productJson = $.parseJSON(product);
    if (productJson != null && productJson != undefined) {
      lot.name = productJson.Name;
      lot.type = productJson.ProductType;
      lot.size = productJson.LotArea;
      lot.price = productJson.DisplayPrice;
      lot.stage = productJson.MarketingReleaseName;
      lot.bedrooms = productJson.Bedrooms;
      lot.bathrooms = productJson.Bathrooms;
      lot.car_spaces = productJson.Garage;
      lot.stories = productJson.Storeys;
      lot.product_id = productJson.ID;
      lot.open_times = productJson.DisplaySuiteText;
      lot.builder = productJson.BuilderName;
      lot.frontage = productJson.LotWidth;
    }
  }

  dataLayer.push({
    event: 'save_and_compare',
    community: community,
    lot: lot
  });
};

// GTM (Lot Search)
export const gtmLotSearch = (el = null) => {
  console.log('gtmLotSearch fired');
  let community = {};
  let projectGAInfo = document.getElementById("ProjectGAInfo");
    
  if (projectGAInfo != null && projectGAInfo != undefined) {
    community.name = projectGAInfo.getAttribute("data-community-name") || "corporate";
    community.region = projectGAInfo.getAttribute("data-community-region");
    community.availability = projectGAInfo.getAttribute("data-community-availability");
  }

  let count = 9; // In case we can't get an exact count of how many choices there are we'll assume a not rediculous number.
  let countPropertyTypes = document.querySelectorAll('.form__control-group--property-type');
  if (countPropertyTypes !== undefined || countPropertyTypes !== null) {
    count = countPropertyTypes.length;
  } 
  let propertyTypes = [];
  for (var i = 0; i < count; i++) {
    let checkedElement = 'PropertyTypes_' + i + '__IsChecked';
    let valueElement = 'PropertyTypes_' + i + '__Value';
    if (el.form.elements[checkedElement] !== undefined) {
      let checkedState = el.form.elements[checkedElement].checked;
      let value = el.form.elements[valueElement].value;
      let type = {
        "checked": checkedState,
        "value": value
      };
      propertyTypes.push(type);
    }
  }

  let string = '';
  for (const item of propertyTypes) {
    if (item.checked || el.form.elements['PropertyTypes'].checked) {
      if (string.length > 0) {
        string += "|";
      }
      string += item.value;
    }
  }

  dataLayer.push({
    event: 'lot_search',
    community: community,
    property_types: string, // eg: All property types, sourced from property-types
    min_price: parseInt(el.form.elements['MinPrice'].value), // 129900 (int not string)
    max_price: parseInt(el.form.elements['MaxPrice'].value) // 549900 (int not string)
  });
};

// GTM (Click on Banner/CTA)
export const gtmClickOnBannerCTA = (el = null) => {
  console.log('gtmClickOnBannerCTA fired');

  let community = {};
  let projectGAInfo = document.getElementById("ProjectGAInfo");

    if (projectGAInfo != null && projectGAInfo != undefined) {
        community.name = projectGAInfo.getAttribute("data-community-name") || "corporate";
        community.region = projectGAInfo.getAttribute("data-community-region");
        community.availability = projectGAInfo.getAttribute("data-community-availability");
    } else {
        community.name = "corporate";
        community.region = "";
        community.availability = "";
    }

  dataLayer.push({
    event: 'click_cta',
    community: community,
    promotion_name: $('.carousel-controller__data > .carousel-item__title')[0].textContent, // '{{ name of promotion }}', // The Future is Brabham
    cta_text: $('.carousel-controller__data > .carousel-item__cta')[0].innerText // '{{ text on CTA }}' // Discover our living options
  });
};
